<template>
  <v-app
    id="inspire"
  >
    <v-navigation-drawer
      v-model="drawer"
      app
      :disable-route-watcher="this.$router.currentRoute.path.includes('search')"
    >
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">
            {{ $vuetify.lang.t('$vuetify.navigation') }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-divider />
      <v-list
        nav
      >
        <v-list-item
          v-for="item in menuItems"
          :key="item.title"
          link
          :to="item.routerLink"
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app>
      <v-btn
        class="ml-1"
        icon
        @click="drawer = !drawer"
      >
        <v-icon>
          menu
        </v-icon>
      </v-btn>

      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip
        v-if="this.$router.currentRoute.name == 'SearchResult' || this.$router.currentRoute.name == 'Search'"
        v-model="showToolTip"
        bottom
      >
        <template v-slot:activator="{ on, attrs }">
          <v-icon
            v-bind="attrs"
            v-on="on"
            @click="showToolTip = !showToolTip"
          >
            info
          </v-icon>
        </template>
        <span
          v-if="this.$router.currentRoute.name == 'SearchResult'"
        >
          {{ $vuetify.lang.t('$vuetify.helpSearchResult') }}
        </span>
        <span
          v-if="this.$router.currentRoute.name == 'Search'"
        >
          {{ $vuetify.lang.t('$vuetify.helpSearch') }}
        </span>
      </v-tooltip>
      <v-btn
        icon
        @click="$vuetify.theme.dark = !$vuetify.theme.dark"
      >
        <v-icon>brightness_6</v-icon>
      </v-btn>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            icon
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>translate</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in languages"
            :key="index"
            @click="updateLanguage(item.code)"
          >
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu
        v-if="username != ''"
        top
        :close-on-click="true"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-avatar
            color="indigo"
            size="36"
            v-bind="attrs"
            v-on="on"
          >
            <span>{{ username.charAt(0) }}</span>
          </v-avatar>
        </template>

        <v-btn @click="logout()">
          {{ $vuetify.lang.t('$vuetify.logout') }}
        </v-btn>
      </v-menu>
    </v-app-bar>

    <v-main>
      <v-container>
        <v-row
          justify="center"
        >
          <v-col
            cols="12"
            sm="8"
          >
            <v-sheet
              rounded="lg"
            >
              <v-container>
                <router-view
                  v-if="autoLoginDone"
                  :desktop="desktop"
                  :api="api"
                  :username="username"
                  :songs="songs"
                  @fetchData="autoLogin"
                  @search="onSearch"
                  @nextQuery="onNextQuery"
                  @httpError="showSnackbar"
                  @showSnackbar="showSnackbar"
                />
              </v-container>
            </v-sheet>
          </v-col>
        </v-row>
      </v-container>
      <v-snackbar
        v-model="snackbarVisible"
      >
        {{ snackbarMessage }}

        <template v-slot:action="{ attrs }">
          <v-btn
            color="pink"
            text
            v-bind="attrs"
            @click="snackbarVisible = false"
          >
            {{ $vuetify.lang.t('$vuetify.close') }}
          </v-btn>
        </template>
      </v-snackbar>
    </v-main>
  </v-app>
</template>
<script>
  export default {
    data: () => ({
      languages: [
        { name: "English", code: "en" },
        { name: "Nederlands", code: "nl" },
        { name: "Esperanto", code: "eo" },
        { name: "Norsk", code: "no" },
      ],
      loggedIn: false,
      drawer: false,
      showToolTip: false,
      snackbarVisible: false,
      snackbarMessage: "",
      queries: [],
      queryIndex: 0,
      username: "",
      songs: [],
      autoLoginDone: false,
    }),
    computed: {
      api: function () {
        return `/api/${this.$vuetify.lang.current}`
      },
      title: function () {
        return this.$vuetify.lang.t('$vuetify.title')
      },
      menuItems: function () {
        return [
        { title: this.$vuetify.lang.t('$vuetify.search'), routerLink: '/', icon: 'search' },
        { title: this.$vuetify.lang.t('$vuetify.library'), routerLink: '/library', icon: 'library_music' },
        { title: this.$vuetify.lang.t('$vuetify.about'), routerLink: '/about', icon: 'info' },
      ]
      } ,
      desktop: function () {
        return !this.$vuetify.breakpoint.xsOnly
      },
    },
    mounted: function () {
      this.drawer = this.desktop;
      this.autoLogin()
    },
    methods: {
      updateLanguage: function (lang){
        let self = this
        this.$vuetify.lang.current = lang
        document.title = this.$vuetify.lang.t('$vuetify.title')
        if (this.loggedIn) {
          this.axios.put(`${this.api}/user/`, {
            "lang": lang
          }).then(function(response) {
            self.showSnackbar(response.data)
          }).catch(function (error){
            self.showSnackbar(error.response.data)
          })
        }
      },
      onSearch: async function (data) {
        this.queries = data[0]
        for (let i = 0; i < this.queries.length; i++){
          if (this.queries[i] == "") return;
        }
        let milliseconds = 60 / (data[1] / 4) * 1000
        let jazzMode = data[2] ? "jazz" : "pop"
        // NaN is the only value that is not equal to itself
        this.queryIndex = 0
        if (milliseconds !== milliseconds || this.queries.length <= 1){
          this.$router.push(`/search/${jazzMode}/${this.queries[0]}/0/0/0`)
        } else {
          const sleep = (delay) => new Promise((resolve) => setTimeout(resolve, delay))
          this.onNextQuery(0, jazzMode)
          await sleep(milliseconds)
          // TODO this for loop is hacky
          for (let i = 0; i < 1000; i++){
            if (!this.$router.currentRoute.path.includes("search")) break
            this.onNextQuery(1, jazzMode)
            await sleep(milliseconds)
          }

        }
      },
      onNextQuery: function (x, mode){
        let queryIndex = this.indexModulus(this.queries.length, this.queryIndex + parseInt(x))
        this.queryIndex = queryIndex
        mode = this.$route.params.mode ?? "jazz"
        let synonym = this.$route.params.synonym ?? 0
        let sheet = this.$route.params.sheet ?? 0
        let index = this.$route.params.index ?? 0
        this.$router.push(`/search/${mode}/${this.queries[queryIndex]}/${synonym}/${sheet}/${index}`)
      },
      indexModulus: function (length, index) {
        if (length === 1) return 0
        if(index >= 0){
          return index % length
        } else {
          return -(-index % length) + length
        }
      },
      showSnackbar: function (message){
        this.snackbarMessage = message;
        // Make it false first, so if multiple snackbars are visible the new one will start with a 'fresh' timeout period
        this.snackbarVisible = false;
        this.snackbarVisible = true;
      },
      logout: function () {
        let self = this;
        this.axios.post(`${this.api}/auth/logout/`).then(function() {
          self.username = ""
          self.songs = []
        }).catch(function (error){
          self.showSnackbar(error.response.data)
        })
      },
      autoLogin: function () {
        let self = this;
        this.axios.get(`${this.api}/user/`).then(function(response) {
          self.username = response.data.name ?? ""
          self.songs = response.data.songs ?? []
          self.$vuetify.lang.current = response.data.ui_lang ?? "en"
          self.autoLoginDone = true;
          self.loggedIn = true;
          document.title = self.$vuetify.lang.t('$vuetify.title')
        }).catch(function (error){
          self.autoLoginDone = true;
          if (!error.response.data.includes("Unauthorized or not logged in")) {
            self.showSnackbar(error.response.data)
          }
        })
      }
    }
  }
</script>
